import React from "react";
import {
  StudentPendingOutlined,
  AssessmentAddOutlined,
} from "@toddle-edu/ds-icons";
import { getIsLearningCoursesEnabled } from "LearningCourses/modules/Utils";
import { isToddleLibraryRouteBySegment as isToddleLibraryRoute } from "Utils/RouteMatchUtils";

export const ADMIN_ROLES = ["PYP Coordinator", "School leader"];

export const getCommunityImportOptions = params => {
  const { t, isTermsExist } = params;

  return [
    {
      key: "ASSIGN_TO_STUDENTS",
      label: t("common:assign_to_students"),
      icon: <StudentPendingOutlined />,
      disabled: !isTermsExist,
      disabledTooltip: !isTermsExist
        ? t(
            "classRoom:assign_to_students_no_grading_periods_tooltip_with_label_plural",
            {
              label: t("common:learning_experience"),
            }
          )
        : null,
    },
    {
      key: "IMPORT_IN_UNIT",
      label: t("classRoom:add_to_label", {
        label: t("common:unit"),
      }),
      icon: <AssessmentAddOutlined />,
    },
  ];
};

export const getAssignmentModalData = params => {
  const { t, type } = params;

  const isLearningCoursesEnabled = getIsLearningCoursesEnabled();
  const isToddleLibrary = isToddleLibraryRoute();

  switch (type) {
    case "ASSIGN_TO_STUDENTS":
      return {
        mode: "create",
        creationMode: "ASSIGN_TO_CLASS",
        steps: [
          {
            label: t("common:edit_with_label", {
              label: t("common:post"),
            }),
            value: "ASSESSMENT_DETAILS",
          },
          {
            label: t("classRoom:post_settings"),
            value: "SETTINGS",
          },
        ],
        contentType: "ASSESSMENT",
        createHeader: t("common:assign_to_students"),
        updateUnitPlanDataInRedux: false,
      };
    case "COMMUNITY":
      return {
        mode: "create",
        creationMode: isLearningCoursesEnabled
          ? "ASSIGN_TO_COURSE"
          : "IMPORT_IN_CLASS",
        steps: [
          isLearningCoursesEnabled && !isToddleLibrary
            ? {
                label: t("toddleLibrary:select_course"),
                value: "LEARNING_COURSE_SELECTION",
              }
            : {
                label: t("common:select_with_label", {
                  label: isLearningCoursesEnabled
                    ? t("common:learning_course")
                    : t("common:class"),
                }),
                value: "CLASS_SELECTION",
              },
          {
            label: t("common:edit_with_label", {
              label: t("community:learning_experience"),
            }),
            value: "ASSESSMENT_DETAILS",
          },
          {
            label: t("classRoom:post_settings"),
            value: "SETTINGS",
          },
        ],
        contentType: "ASSESSMENT",
        createHeader: isLearningCoursesEnabled
          ? t("community:add_le_to_course")
          : t("community:add_le_to_class"),
        updateUnitPlanDataInRedux: false,
      };
  }
};
